// extracted by mini-css-extract-plugin
module.exports = {"dataCell":"ClientsTable_dataCell__2_4Lx","headerCell":"ClientsTable_headerCell__17lgy","ellipseCell":"ClientsTable_ellipseCell__3yXdW","tooltip":"ClientsTable_tooltip__2ta2A"};